// eslint-disable-next-line @nx/enforce-module-boundaries
import { DataTableHeader } from '@occc/ui-design-system';

export const headers: DataTableHeader[] = [
  { label: 'Member Name' },
  { label: 'Phone Number' },
  { label: 'Entered Date' },
  { label: 'Reason' },
  { label: '' },
];
